import { httpGet } from "../../../common/network/fetch";
import { GetWhoAmIResponse, IGetWhoAmIResponse } from "./get-who-ami-i-response";

export const GetWhoAmIHandler = async () =>
    new GetWhoAmIResponse(await httpGet<IGetWhoAmIResponse>({ url: "/auth/whoami" }, false));
